/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TabNav from "../../components/TabNav";

import DataTable, { Column } from "components/DataTable";
import { StatusChip } from "components/StatusChip";
import { useAuth } from "contexts/AuthContext";
import { useHasRole } from "contexts/AuthContext";
import {
  fetchAdvocateComplaintByAdminUnitId,
  fetchAdvocateComplaintByProsecutor,
} from "services/advocateComplaintService";
import { AdvocateComplaints } from "types";
import { COMPLIANT_STATUS } from "utils/constantValues";
import { DateView } from "utils/helper";
import { ADVOCATE_ROLES } from "utils/roles";
import { useTranslation } from "contexts/i18nContext";
import "../complaintRequest/complaintRequest.css";

const tabs = [
  "All",
  COMPLIANT_STATUS.PENDING,
  COMPLIANT_STATUS.UNDER_INVESTIGATION,
  COMPLIANT_STATUS.DRAFT_CHARGE,
  COMPLIANT_STATUS.UNDER_LITIGATION,
  COMPLIANT_STATUS.CLOSED,
];

const AdvocateComplaint: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user } = useAuth();
  const canCreateComplaint = useHasRole([
    ADVOCATE_ROLES.INSPECTION_COORDINATOR,
  ]);
  const isProsecutor = useHasRole([ADVOCATE_ROLES.INSPECTION_PROSECUTOR]);
  // const canViewAllComplaint = useHasRole([
  //   ADVOCATE_ROLES.INSPECTION_COORDINATOR,
  //   ADVOCATE_ROLES.INSPECTION_DIRECTOR,
  //   ADVOCATE_ROLES.INSPECTION_REGISTRAR,
  // ]);
  // const canOnlyViewAssignedComplaint = useHasRole([
  //   ADVOCATE_ROLES.INSPECTION_PROSECUTOR,
  // ]);
  // const canOnlyViewCouncilComplaint = useHasRole([
  //   ADVOCATE_ROLES.ZONAL_COUNCIL_OFFICE_HEAD,
  //   ADVOCATE_ROLES.REGIONAL_COUNCIL_OFFICE_HEAD,
  //   ADVOCATE_ROLES.ZONAL_COUNCIL_OFFICE_WRITER,
  //   ADVOCATE_ROLES.REGIONAL_COUNCIL_OFFICE_WRITER,
  //   ADVOCATE_ROLES.ZONAL_OFFICE_OF_COUNCIL_COORDINATOR,
  //   ADVOCATE_ROLES.ZONAL_COUNCIL_OFFICE_WRITER,
  // ]);

  const [activeTab, setActiveTab] = useState<string>("All");
  const [loading, setLoading] = useState(true);
  // const [error, setError] = useState("");
  const [complaints, setComplaints] = useState<AdvocateComplaints[]>([]);
  const [searchQuery, setSearchQuery] = useState<string>("");

  useEffect(() => {
    const loadComplaints = async () => {
      setLoading(true);
      try {
        const data = isProsecutor
          ? await fetchAdvocateComplaintByProsecutor(user?.user_id || "")
          : await fetchAdvocateComplaintByAdminUnitId(user?.admin_unit || "");
        setComplaints(data);
        // setError("");
      } catch (err) {
        // setError("Failed to load complaint.");
      } finally {
        setLoading(false);
      }
    };
    loadComplaints();
  }, []);

  function newComplaint() {
    navigate("/advocate-complaint/new");
  }

  const columns: Column<AdvocateComplaints>[] = [
    {
      header: t("accusedAdvocate"),
      accessor: "accused_name",
      render: (row) => (
        <div className="flex items-center gap-3">
          <img
            src={require("../../images/avatar.png")}
            className="w-10 h-10 rounded-full grayscale"
          />
          <span>{row.accused_name}</span>
        </div>
      ),
      widthClass: "w-1/5",
    },
    {
      header: t("licenseNumber"),
      accessor: "accused_license_number",
      render: (row) => row.accused_license_number || "—",
    },
    {
      header: t("assignedTo"),
      accessor: "assignedTo",
      render: (row) => row.assigned_prosecutor ?? "—",
    },
    {
      header: t("appliedDate"),
      accessor: "reception_date",
      render: (row) => DateView(row.reception_date),
    },
    {
      header: t("status"),
      accessor: "status",
      render: (row) => <StatusChip status={row?.status || ""} />,
    },
    // { header: t("phoneNumber"), accessor: "accused_prosecutor_phone" },
    {
      header: t("assign"),
      accessor: "id",
      render: (row) =>
        row.assigned_prosecutor ? (
          <span className="text-green-600 font-medium">{t("assigned")}</span>
        ) : (
          <button disabled className="px-4 py-1 text-sm bg-gray-200 rounded ">
            {t("assign")}
          </button>
        ),
    },
    {
      header: t("action"),
      accessor: "action",
      render: (row: any) => (
        <button
          onClick={() => navigate(`/advocate-complaint/${row?.uu_id}`)}
          className="px-3 py-1 text-sm bg-black text-white rounded hover:bg-gray-800 transition"
        >
          {t("open")}
        </button>
      ),
    },
  ];

  return (
    <div className=" mx-auto flex flex-col space-y-4">
      <h1 className="text-2xl font-semibold text-gray-700 flex items-center gap-2 mb-5">
        <span>⚖</span>
        {t("advocateComplaintReceptionRequests")}
      </h1>

      {/* Header: Tabs + Add button */}
      <div className="w-full flex flex-wrap items-center justify-between gap-4 mb-5">
        <TabNav active={activeTab} tabs={tabs} onSelect={setActiveTab} />

        {canCreateComplaint && (
          <button
            onClick={newComplaint}
            className="px-5 py-2 text-sm font-semibold text-white bg-green-600 rounded hover:bg-green-700 transition"
          >
            {t("addNewComplaint")}
          </button>
        )}
      </div>

      <DataTable
        title={t("serviceRequestTable")}
        columns={columns}
        data={[...(complaints || [])]
          .sort(
            (a, b) =>
              new Date(b?.createdAt ?? "").getTime() -
              new Date(a?.createdAt ?? "").getTime(),
          )
          ?.filter((obj) => activeTab === "All" || obj.status === activeTab)
          ?.filter((obj) => {
            if (!searchQuery.trim()) return true;

            const query = searchQuery.toLowerCase();
            const accusedName = obj.accused_name?.toLowerCase() || "";
            const licenseNumber =
              obj.accused_license_number?.toLowerCase() || "";

            return accusedName.includes(query) || licenseNumber.includes(query);
          })
        // ?.filter(
        //   (obj) =>
        //     (canViewAllComplaint && obj?.admin_unit_id === user?.admin_unit) ||
        //     (canOnlyViewAssignedComplaint &&
        //       obj.userid_assigned_prosecutor === user.user_id) ||
        //     (canOnlyViewCouncilComplaint && obj.has_councile)
        // )
        }
        rowKey={(row) => row.uu_id}
        onSearch={(q) => setSearchQuery(q)}
        isLoading={loading}
      />
    </div>
  );
};

export default AdvocateComplaint;
